<template>
  <div class="rm-screen">
    <div v-if="!selectedCompany" class="rm-empty">
      <v-icon size="40" color="#8a817a">mdi-domain</v-icon>
      {{ $t("report_mobile.employees_pick_company") }}
    </div>
    <div v-else-if="loading && !orderUsers.length" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>

    <template v-else>
      <div class="rm-stats">
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("ordered") }}</span>
          <span class="rm-stat__value rm-num">{{ stats.ordered }}</span>
        </div>
        <div class="rm-stat">
          <span class="rm-stat__label">{{ $t("taken") }}</span>
          <span class="rm-stat__value rm-num">{{ stats.taken }}</span>
        </div>
        <div class="rm-stat rm-stat--accent">
          <span class="rm-stat__label">{{ $t("difference") }}</span>
          <span class="rm-stat__value rm-num">{{ stats.difference }}</span>
        </div>
      </div>

      <div class="rm-chip-row gm-chips" role="group" :aria-label="$t('order_status')">
        <button
          v-for="item in statusChips"
          :key="item.value"
          type="button"
          class="rm-chip"
          :class="{ 'rm-chip--active': orderStatus === item.value }"
          :aria-pressed="String(orderStatus === item.value)"
          @click="orderStatus = item.value"
        >
          {{ item.label }}
          <span class="rm-num gm-status__n">{{ item.count }}</span>
        </button>
      </div>

      <template v-if="shownRows.length">
        <ul class="rm-list rm-card">
          <li v-for="row in shownRows" :key="row.key" class="gm-user">
            <button type="button" class="gm-user__btn" @click="openWorker(row)">
              <span class="gm-user__text">
                <span class="gm-user__name">{{ row.name }}</span>
                <span class="gm-user__meta rm-num">{{ row.meta }}</span>
                <span v-if="row.shifts.length" class="gm-user__shifts">
                  <report-shift-tag v-for="shift in row.shifts" :key="shift" :shift="shift"></report-shift-tag>
                </span>
              </span>
              <span class="rm-status" :class="`rm-status--${row.state === 'off' ? 'idle' : row.state}`">
                {{ row.statusLabel }}
              </span>
              <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
            </button>
          </li>
        </ul>
        <button v-if="hiddenCount > 0" type="button" class="rm-text-btn gm-user__more" @click="expanded = true">
          {{ $t("report_mobile.show_more", { items: pluralT("report_mobile.workers_n", hiddenCount) }) }}
        </button>
      </template>
      <div v-else class="rm-empty">{{ emptyText }}</div>
    </template>
  </div>
</template>

<script>
import ReportTabGroupMealsTabEmployees from "@/components/report/group-meals/ReportTabGroupMealsTabEmployees.vue";
import { SHIFTS } from "@/constants/shifts";
import hasPlural from "../../../shared/hasPlural";
import hasGroupUserRows from "../../../shared/group/hasGroupUserRows";
import ReportShiftTag from "../../../shared/ReportShiftTag.vue";
import "./groupMobileUsers.scss";

const PAGE_SIZE = 15;

/**
 * Mobilni "Korisnici" (jela iz grupa): poručeno / preuzeto / razlika po radniku, sa smenom u kojoj je poručio, uz
 * radnike koji nisu poručili. Filter statusa je red čipova sa brojem radnika; klik na radnika otvara njegov
 * mesečni pregled. Firma i period su u zaglavlju. Nasleđuje učitavanje, štampu i Excel iz starog taba.
 */
export default {
  name: "GroupMobileUsers",
  extends: ReportTabGroupMealsTabEmployees,
  mixins: [hasPlural, hasGroupUserRows],
  components: { ReportShiftTag },
  data: () => ({
    expanded: false,
  }),
  computed: {
    stats() {
      const ordered = this.matchedRows.reduce((sum, row) => sum + row.ordered, 0);
      const taken = this.matchedRows.reduce((sum, row) => sum + row.taken, 0);
      return { ordered, taken, difference: ordered - taken };
    },
    shownRows() {
      const rows = this.matchedRows.map((row) => ({
        ...row,
        meta: [`ID ${row.id}`, row.time, row.externalCode].filter(Boolean).join(" · "),
        shifts: SHIFTS.filter((shift) => row[shift.key] > 0).map((shift) => shift.id),
      }));
      return this.expanded || this.filters.search ? rows : rows.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.matchedRows.length - this.shownRows.length;
    },
  },
  watch: {
    orderStatus() {
      this.expanded = false;
    },
  },
  methods: {
    openWorker(row) {
      this.$store.commit("report/SET_SELECTED_EMPLOYEE", this.toEmployeeContext(row));
      this.$emit("open-screen", "employee");
    },
  },
};
</script>
